import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { StakingPage } from "../../features/staking/pages/staking-page";

export const Route = createFileRoute("/_layout/staking")({
  component: StakingLayout,
});

function StakingLayout() {
  const location = useLocation();

  // Check if we're on main staking tab routes or unstake paths
  const isMainStakingPath =
    /^\/staking\/(positions|idle|activity)$/.test(location.pathname) ||
    location.pathname === "/staking";
  const isUnstakePath = /^\/staking\/[^/]+\/unstake\/[^/]+$/.test(location.pathname);

  // Render StakingPage layout for main tab routes and unstake paths
  // Otherwise render child routes (like /staking/eth for EarnPage)
  return isMainStakingPath || isUnstakePath ? <StakingPage /> : <Outlet />;
}
